import { addToDataLayer } from './dataLayer';
import { EventType } from './eventType';

export function logError(errorType: string) {
  addToDataLayer({
    event: EventType.errorViewErrorMessage,
    error_type: errorType
  });
}